import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import User from "../../stores/UserStore";
import General from "../../stores/GeneralStore";
import "./forgotusername.css";
import { Container } from "../login.screen/login.styled";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import "./forgotusername.css"
import { observer } from "mobx-react";
// Your other imports for custom components and styles

const DEFAULT_SENTINEL_VALUE = "";

const renderButtonContent = (isSubmitting: any) => {
  return isSubmitting ? (
    <Spinner width="30px" height="30px" style={{ color: "white" }} />
  ) : (
    General?.codeLabels["cm_submit"]?.label
  );
};

const validationSchema = Yup.object().shape({
  account: Yup.string().required(General?.codeLabels["cm_pdc_accnumval"]?.label), 
  email:  Yup.string().matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, General.codeLabels['cm_emailerr']?.label).required(General?.codeLabels["cm_email_rqd"]?.label),
});

const ForgotUsername = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");

  const initialValues = {
    account: DEFAULT_SENTINEL_VALUE,
    email: DEFAULT_SENTINEL_VALUE,
  };

  const handleSubmit = async (values: any) => {
    try {
    const res=  await User.forgotUserName({
        errorId: "forgotPasswordError",
        data: { email: values.email, account: values.account },
      });
      if(res?.message == "Success"){
        navigate('/')
      }
    } catch (error) {
      setMessage("An error occurred while processing your request.");
    }
  };

  return (
    <Container style={{minHeight:'70vh'}}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100%",
        }}
        className="forgotusername-container"
      >
        <Box
          sx={{
            width:General?.isLargeScreen? "600px":"100%",
            padding: "50px",
            backgroundColor: "#fff",
          }}
        >
          <h2
            style={{
              alignSelf: "center",
              fontWeight: "500",
              fontSize:General?.isLargeScreen? `${2.5 * General.accessibility.fontSize}rem`:`${1.5* General.accessibility.fontSize}rem`,
              color: "#101e8e",
            }}
          >
               {General?.codeLabels["cm_forgotun"]?.label !== undefined
            ? General?.codeLabels["cm_forgotun"]?.label
            : "Forgot Username"}
          </h2>
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, isValid, dirty, values }) => (
              <Form>
                <Box sx={{ marginBottom: "16px" }}>
                  <label
                    htmlFor="account"
                    style={{
                      fontSize: `${0.8 * General.accessibility.fontSize}rem`,
                      color: "#101e8e",
                    }}
                  >
                  {General?.codeLabels["cm_enteraccid"]?.label !== undefined
                  ? General?.codeLabels["cm_enteraccid"]?.label
                  : "Enter account number"}
                  </label>
                  <Field
                  type="text"
                  name="account" 
                  className="input-field"
                  placeholder={General?.codeLabels["cm_enteraccid"]?.label}
                  onKeyPress={(e: React.KeyboardEvent) => {
                    if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                    }
                  }}
                  style={{
                    width: "100%",
                    height: "40px",
                    padding: "8px",
                    border: "1px solid rgba(182, 191, 220, 1)",
                    backgroundColor: "rgba(229, 239, 242, 0.7)",
                    color: "#101e8e",
                  }}
                  />
                  <ErrorMessage
                    name="account"
                    component="div"
                    className="error-message"
                  />
                </Box>

                <Box sx={{ marginBottom: "16px" }}>
                  <label
                    htmlFor="email"
                    style={{
                      fontSize: `${0.8 * General.accessibility.fontSize}rem`,
                      color: "#101e8e",
                    }}
                  >
                    {General?.codeLabels["cm_enteremail"]?.label}
                  </label>
                  <Field
                    type="email"
                    name="email"
                    className="input-field"
                    placeholder={General?.codeLabels["cm_enteremail"]?.label}
                    style={{
                      width: "100%",
                      height: "40px",
                      padding: "8px",

                      border: "1px solid rgba(182, 191, 220, 1)",
                      backgroundColor: "rgba(229, 239, 242, 0.7)",
                      color: "#101e8e",
                    }}
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error-message"
                  />
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    marginTop: "40px",
                    gap: "10px",
                  }}
                >
                  <button
                    style={{
                      height: "3rem",
                      width: "100px",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                      alignItems: "center",
                      backgroundColor: "#101e8e",
                      cursor: "pointer",
                      color: "white",
                      fontWeight: "700",
                      border: "none",
                    }}
                    onClick={() => navigate("/")}
                  >
                    {General?.codeLabels["cm_usepassloginpagecancel"]?.label}
                  </button>
                  <button
                    type="submit"
                    disabled={
                      isSubmitting || 
                      !isValid || 
                      !dirty ||
                      !values.account ||
                      !values.email
                    }
                    style={{
                      height: "3rem",
                      width: "132px",
                      display: "flex",
                      justifyContent: "center",
                      textAlign: "center",
                      fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                      alignItems: "center",
                      backgroundColor: "#101e8e",
                      cursor: isSubmitting || !isValid || !dirty || !values.account || !values.email ? 
                        "not-allowed" : "pointer",
                      opacity: isSubmitting || !isValid || !dirty || !values.account || !values.email ? 
                        0.6 : 1,
                      color: "white",
                      fontWeight: "700",
                      border: "none",
                    }}
                  >
                    {renderButtonContent(isSubmitting)}
                  </button>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Box>
    </Container>
  );
};

export default observer(ForgotUsername);
